/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsBlog = {
  init: function($section){

    // Add settings from schema to current object
    Shopify.theme.jsBlog = $.extend(this, Shopify.theme.getSectionData($section));

    if(this.enable_filter == true) {
      $('#blog_filter').on('change', function() {
        Shopify.theme.jsBlog.blogFilter();
      });
    }

    $(document).ready(function () {
      $('.tag-filtered-result').on('click', function (e) {
        e.stopPropagation();
        $(this).parent().toggleClass('active');
      });

      $('.blog-dropdown-filter .custom-tag-filter li').on('click', function (e) {
        e.stopPropagation();

        var selectedText = $(this).text().trim();
        $('.tag-filtered-result span').text(selectedText);
        var $select = $('.blog__filter select');

        $select.find('option').each(function () {
          if ($(this).text().trim() === selectedText) {
            $(this).prop('selected', true);
            $select.trigger('change');
          }
        });

        $(this).closest('.active').removeClass('active');
      });

      $(document).on('click', function () {
        $('.active').removeClass('active');
      });
    });

  },
  blogFilter: function() {
    let url = $('#blog_filter').val();
    window.location = url;
  },
  unload: function($section) {
    $('#blog_filter').off();
  }
}
/******/ })()
;